import { graphql } from "gatsby";
import React from "react";
import Layout from "./components/Layout";

export default function CookiePolicy() {
  return (
    <Layout>
      <main className="d-flex flex-fill">
        <div className="container px-4 px-md-3">
          Falta escrever. Informação pode ser consultada no seguinte endereço
          <a href="https://ec.europa.eu/info/cookies_en" target={"_blank"} rel="noreferrer">
            Cookies policy
          </a>
        </div>
      </main>
    </Layout>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
